import React from "react";
import SingleClickToFlyResultContent from "../components/click-to-fly/single-click-to-fly-result-content";

const SingleClickToFlyResult = () => {
  return <SingleClickToFlyResultContent />;
};

export default SingleClickToFlyResult;

